// axios 拦截器
import axios from "axios";
import { ElMessage, ElMessageBox } from 'element-plus'
import router from '../router/index'

const errCodes = [11011, 11012, 11013, 11014, 11015, 11016];
const authMessageMap = {
    11011: '登录状态已过期，请重新登录后继续使用',
    11012: '登录状态已过期，请重新登录后继续使用',
    11013: '登录状态已过期，请重新登录后继续使用',
    11014: '账号已在其他设备登录，请重新登录',
    11015: '当前账号已下线，请重新登录',
    11016: '账号已被冻结，请联系管理员处理'
};

let authDialogVisible = false;

function getAuthMessage(code, fallback) {
    return authMessageMap[code] || fallback || '登录状态异常，请重新登录';
}

function handleAuthError(code, fallback) {
    if (authDialogVisible) {
        return;
    }
    authDialogVisible = true;
    ElMessageBox.alert(getAuthMessage(code, fallback), '需要重新登录', {
        type: 'warning',
        showClose: false,
        confirmButtonText: '去登录',
        callback: () => {
            authDialogVisible = false;
            localStorage.removeItem("token");
            router.push("/login");
        },
    })
}

// 请求发出之前的拦截器
axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem("token");
    if (token) {
        if (config.url != "/api/bms/auth/login") {
            config.headers.satoken = `${token}`;
        };
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 请求响应之后的拦截器
axios.interceptors.response.use(function (response) {
    if (response.config.responseType !== 'blob') {
        // 成功
        if (response.request.responseURL.includes('/api/bms/auth/login')) {
            // 登录接口
            if (response.data.code == 200) {
                const { accessToken } = response.data.data;
                accessToken && localStorage.setItem("token", accessToken);
            }
        }
        if (response.data.code != 200) {
            // 错误信息统一处理
            if (errCodes.includes(response.data.code)) {
                handleAuthError(response.data.code, response.data.msg);
            } else {
                ElMessage.error(response.data.msg || '操作失败，请稍后再试');
            }
        }
    }
    return response;
}, function (error) {
    // 失败
    const data = error.response?.data || {};
    if (errCodes.includes(data.code)) {
        handleAuthError(data.code, data.msg);
    } else {
        ElMessage.error(data.msg || '网络开小差了，请稍后再试');
    }
    return Promise.reject(error);
});
